import _ from 'lodash'

//import SETTINGS from '@/plugins/settings'

import Action from '@/models/action'
import Pipeline from '@/models/pipeline'
import Provider from '@/models/provider'
import User from '@/models/user'

const Utility = {

  computed:
  {
    /*
    appName()
    {
      return SETTINGS.APP_NAME
    },
    */

    isMobile()
    {
      return this.$vuetify.breakpoint.smAndDown
    },

    isSmartphone()
    {
      return this.$vuetify.breakpoint.xs
    }
  },

  methods:
  {
    goTo(where)
    {
       if( typeof where == 'string' )
         where = { name:where }

       this.$router.push(where).catch(()=>{})
    },

    mapModel(model, classToMap='pipeline')
    {
      return this.mapModels([model], classToMap)[0]
    },

    mapModels(models=[], classToMap='pipeline')
    {
      return _.map(models, (model)=>{

        switch( classToMap.toLowerCase() ){
          case 'action': return new Action(model)
          case 'pipeline': return new Pipeline(model)
          case 'provider': return new Provider(model)
          case 'user': return new User(model)
          default: return model
        }

      })
    },

    scrollTo(el) 
    {
      this.$vuetify.goTo( `#${el}`, { offset: 60 })
    },

    /*
    storageUrl(append="")
    {
      return `${SETTINGS.BACKEND_URL}storage/${append}`
    }
    */

  }
}

export default Utility